import React, { useEffect, useState } from "react";
import {
  IonCard,
  IonLabel,
  IonCardHeader,
  IonCardTitle,
  IonList,
  IonItemGroup,
  IonItemDivider,
} from "@ionic/react";
import moment from "moment";
import { useIntl } from "react-intl";
import SchedulingItem from "./SchedulingItem";
const groupBy = require("lodash/groupBy");

const Scheduling = (props) => {
  const { activePlan } = props;
  const intl = useIntl();
  const [tableItems, setTableItems] = useState([]);
  useEffect(() => {
    if (activePlan.recurrent_events && activePlan.recurrent_events.length > 0) {
      const sortedByStartTime = [...activePlan.recurrent_events].sort(
        (a, b) => a.start_time_minutes - b.start_time_minutes
      );

      const sortedByWeekDay = sortedByStartTime.sort(
        (a, b) => a.weekday - b.weekday
      );
      const grouped = groupBy(
        sortedByWeekDay,
        (dt) => moment.weekdays()[dt.weekday]
      );

      setTableItems(grouped);
    }
  }, [activePlan.recurrent_events]);

  return tableItems &&
    Object.keys(tableItems) &&
    Object.keys(tableItems).length > 0 ? (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.plan",
          })}
        </IonCardTitle>
      </IonCardHeader>
      <IonList>
        {Object.keys(tableItems).map((key) => {
          return (
            <IonItemGroup key={key}>
              <IonItemDivider>
                <IonLabel>{key}</IonLabel>
              </IonItemDivider>
              {tableItems[key].map((item) => (
                <SchedulingItem key={item.id} item={item} />
              ))}
            </IonItemGroup>
          );
        })}
      </IonList>
    </IonCard>
  ) : null;
};

export default Scheduling;
